var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAvatar8({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 300,
    height: 300,
    viewBox: "0 0 300 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M300 150C300 232.843 232.843 300 150 300C67.1573 300 0 232.843 0 150C0 67.1573 67.1573 0 150 0C232.843 0 300 67.1573 300 150Z",
    fill: "#AF2C32"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M150 25.1611L168.517 93.0101L223.378 49.0032L198.478 114.778L268.729 111.423L209.922 150L268.729 188.577L198.478 185.221L223.378 250.996L168.517 206.99L150 274.839L131.483 206.99L76.6215 250.996L101.521 185.221L31.2712 188.577L90.0773 150L31.2712 111.423L101.521 114.778L76.6215 49.0032L131.483 93.0101L150 25.1611Z",
    fill: "#FDFC01"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M90.4845 93.8711L117.581 98.7098L135.485 110.807L162.581 108.871L179.519 98.7098L204.68 93.8711L209.033 105L202.743 136.452L211.936 157.742L203.71 190.161L177.581 208.065L139.839 213.387L105.968 201.774L87.5813 166.452L97.2606 142.258L90.4845 93.8711Z",
    fill: "#DA590C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M121.392 167.264L121.381 170.669M175.886 167.453L175.874 170.859M148.852 106.053C153.416 106.069 158.046 106.698 162.469 107.872C174.641 94.2905 196.799 88.6456 206.253 92.6292C215.776 96.6131 203.227 140.301 203.227 140.301C207.084 147.603 209.986 155.583 209.957 163.757C209.852 194.137 182.327 215.157 148.473 215.04C114.619 214.922 87.2395 194.392 87.3474 163.331C87.3769 154.816 90.81 146.995 94.2404 139.922C94.2404 139.922 81.5183 96.1468 91.0002 92.2289C100.482 88.311 123.146 93.9072 135.223 107.573C139.695 106.558 144.267 106.048 148.852 106.053Z",
    stroke: "#740D0A",
    strokeWidth: 14.0775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M143.47 182.667L153.688 182.702L148.561 187.793L143.47 182.667Z",
    stroke: "#740D0A",
    strokeWidth: 14.0775,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAvatar8);
export default __webpack_public_path__ + "static/media/avatar8.60558ac18e5f7db8d5ed58b2ef0ad553.svg";
export { ForwardRef as ReactComponent };